"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    mellomrom: function() {
        return mellomrom;
    },
    mellomromMedTegn: function() {
        return mellomromMedTegn;
    },
    kommaseparert: function() {
        return kommaseparert;
    },
    referanser: function() {
        return referanser;
    },
    datoer: function() {
        return datoer;
    },
    medParentes: function() {
        return medParentes;
    }
});
var _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
var _transformKonstanter = require("./transformKonstanter");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var mellomrom = {
    navn: "Mellomrom",
    description: "Mellomrom mellom referansene",
    verditype: _transformKonstanter.verditype.flere,
    transform: function(felt) {
        for(var _len = arguments.length, verdi = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            verdi[_key - 1] = arguments[_key];
        }
        return verdi.join(" ");
    }
};
var mellomromMedTegn = {
    navn: "MellomromMedTegn",
    description: "Mellomrom med tegn mellom referansene",
    verditype: _transformKonstanter.verditype.flere,
    transform: function(felt) {
        for(var _len = arguments.length, verdi = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            verdi[_key - 1] = arguments[_key];
        }
        return verdi.join(" - ");
    }
};
var kommaseparert = {
    navn: "Kommaseparert",
    description: "Komma og mellomrom mellom referansene",
    verditype: _transformKonstanter.verditype.flere,
    transform: function(felt) {
        for(var _len = arguments.length, verdier = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            verdier[_key - 1] = arguments[_key];
        }
        return verdier.join(", ");
    }
};
var referanser = {
    navn: "Referanser",
    description: "Mapper referansene direkte",
    verditype: _transformKonstanter.verditype.flere,
    transform: function(felt) {
        for(var _len = arguments.length, verdi = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            verdi[_key - 1] = arguments[_key];
        }
        return verdi.join("");
    }
};
var datoer = {
    navn: "Datoer",
    description: "Formater datoer",
    verditype: _transformKonstanter.verditype.flere,
    transform: function(felt) {
        for(var _len = arguments.length, verdi = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            verdi[_key - 1] = arguments[_key];
        }
        return verdi.map(function(v) {
            return (0, _dayjs.default)(v).format("DD.MM.YYYY");
        }).join(" - ");
    }
};
var medParentes = {
    navn: "MedParentes",
    description: "Opptil to verdier, andre verdi i parentes hvis den finnes",
    verditype: _transformKonstanter.verditype.flere,
    transform: function(felt) {
        for(var _len = arguments.length, verdi = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            verdi[_key - 1] = arguments[_key];
        }
        return "".concat(verdi[0] || "").concat(verdi[1] ? " (".concat(verdi[1], ")") : "");
    }
};
